var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import { scrollToElement } from "./BackToTop.utils";
var BackToTop = forwardRef(function (_a, ref) {
    var _b = _a.id, id = _b === void 0 ? "top" : _b, title = _a.title, className = _a.className, style = _a.style, otherProps = __rest(_a, ["id", "title", "className", "style"]);
    var handleClick = function (e) {
        e.preventDefault();
        e.stopPropagation();
        var isKeyboardEvent = true;
        if (e.screenX !== 0 || e.screenY !== 0) {
            isKeyboardEvent = false;
        }
        scrollToElement(id, isKeyboardEvent);
    };
    if (title) {
        console.warn("'title' est dépréciée, vous pouvez supprimer cette props. Le texte 'Haut de page' n'est pas modifiable.");
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("a", __assign({}, otherProps, { ref: ref, href: "#".concat(id), onClick: handleClick, className: "fr-link fr-icon-arrow-up-fill fr-link--icon-left ".concat(className !== null && className !== void 0 ? className : ""), style: style }), "Haut de Page")));
});
export default BackToTop;
